import React, { useEffect, useState } from "react";
import cssStyles from "./cms_renderer.module.scss";

//TODO : need to refactor the existing product_cards.tsx to replace below shop_product_cards.tsx
import './global_functions';

// Import all components from their respective files as default
import Accordion from './Accordion';
import CategoriesCarousel from './CategoriesCarousel';
import CirclerImageButton from './CirclerImageButton';
import ContentOnImage from './ContentOnImage';
import CustButton from './CustButton';
import CustCarousel from './CustCarousel';
import CustImage from './CustImage';
import CustText from './CustText';
import CustVideo from './CustVideo';
import ImageButton from './ImageButton';
import ItemsGrid from './ItemsGrid';
import MarkdownTextPanel from './MarkdownTextPanel';
import OnPageLoadAction from './OnPageLoadAction';
import OpenPopup from './OpenPopup';
import Panel from './Panel';
import ProductsCarousel from './ProductsCarousel';
import Slider from './Slider';
import Title from './Title';
import SubTitle from './SubTitle';
import ExpandableContent from './ExpandableContent';


export interface SectionData {
    backgroundImageUrl?: string;
    buttons?: SectionData[];
    color?: string;
    content?: string | string[] | SectionData; // Used by ContentOnImage
    description?: string | string[];
    footer?: SectionData;
    gridItems?: SectionData[];
    header?: SectionData;
    id?: string;
    imagePanel?: SectionData;
    imageUrl?: string;
    imageUrls?: string[];
    items?: SectionData[] | string[];
    link?: string;
    name?: string;
    newTab?: boolean;
    order?: string[];
    panels?: SectionData[];
    para?: string;
    subTitle?: string;
    text?: string | string[];
    title?: string;
    space?: string;
    trackId?: string;
    trackInfo?: {
        event?: string;
        section?: string;
        [key: string]: any; // Allow other properties in trackInfo
    };
    preProcess?: { // Corrected casing from preProcess to preprocess
        method: string;
        input: any;
    };
    preprocess?: { // Added for consistency with README
        method: string;
        input: any;
    };
    type?: string;
    uiCompType?: UICompType;
    onClick?: { // For CustButton
        method: string;
        input: any;
    };
    include?: string; // For including shared sections

    // For OpenPopup
    dialogProps?: any;
    contentMethod?: string;
    component?: string; // Path for dynamic component import
    input?: any; // Props for dynamically imported component

    // For OnPageLoadAction
    postLoadAction?: {
        method: string;
    };
    inputObj?: any;
    videoUrl?: string; // For CustVideo

    [key: string]: any; // <-- Add this index signature to allow string keys
}

export interface UiCompTypeOptions {
    borderRadius?: string;
    playOnFocusOnly?: any;
    playOnMouseEnter?: any;
    thumbnail?: any;
    align?: string;
    color?: string; // For CustButton
    columns?: number;
    component?: string; // For CustText, OpenPopup
    display?: string;
    gutterBottom?: string;
    height?: string; // For CategoriesCarousel, CirclerImageButton, ImageButton, ProductsCarousel
    imageWidth?: string;
    imageHeight?: string;
    textWidth?: string;
    textHeight?: string;
    swapItems?: boolean; // For ItemsGrid
    swapRowItems?: boolean; // For ItemsGrid
    swapColumnItems?: boolean; // For ItemsGrid
    minHeight?: number; // For MarkdownTextPanel
    noWrap?: boolean;
    parasCount?: number; // For MarkdownTextPanel
    shape?: string;
    size?: string; // For CustButton
    splitRaito?: number;
    sx?: string;
    width?: string; // For CategoriesCarousel, CirclerImageButton, ImageButton, ItemsGrid item
    variant?: string; // For CustText
    markdown?: boolean; // For CirclerImageButton, CustText
    grid?: string; // For ItemsGrid
    spacing?: number | string; // For ItemsGrid
    objectFit?: string; // For CustImage
    carouselProps?: any; // For Slider
    xs?: number | 'auto'; // For ItemsGrid item
    md?: number | 'auto'; // For ItemsGrid item
    lg?: number | 'auto'; // For ItemsGrid item
    preload?: boolean; // For ContentOnImage background image
    newTab?: boolean; // For CustButton, ImageButton
    // For CustVideo
    autoPlay?: boolean;
    loop?: boolean;
    muted?: boolean;
    poster?: string;
    preloadVideo?: "auto" | "metadata" | "none"; // Renamed from 'preload' to avoid conflict
    playsInline?: boolean;
    controls?: boolean;
    quality?: number; // For CustImage (moved from styles as per README example)
}

export interface UICompType {
    method?: string;
    options?: UiCompTypeOptions;
    className?: string;

    styles?: React.CSSProperties;
    mStyles?: React.CSSProperties;
    sectionStyles?: React.CSSProperties;
    mParentStyles?: React.CSSProperties;
    parentStyles?: React.CSSProperties;
    mContainerStyles?: React.CSSProperties;
    containerStyles?: React.CSSProperties;
    imageContainerStyles?: React.CSSProperties;
    imageStyles?: React.CSSProperties;
    itemStyles?: React.CSSProperties;
    mItemStyles?: React.CSSProperties;
    leftArrowStyles?: React.CSSProperties; // For Slider
    rightArrowStyles?: React.CSSProperties; // For Slider
}

export interface PageData {
    page?: string;
    title: string;
    env?: string;
    order: string[];
    description?: string;
    headerJson?: string;
    sections: {
        [key: string]: SectionData;
    };
    trackInfo?: {
        pageType?: string;
        pageName?: string;
        [key: string]: any; // Allow other properties in trackInfo
    };
}

// Define ComponentRenderProps
export interface ComponentRenderProps {
    vendorName?: string;
    cmsData?: PageData; // The full parsed CMS data
    userInfo?: any; // Adjust as per your userInfo structure
    favorites?: any[]; // Adjust as per your favorites structure
    setFavorites?: (favorites: any[]) => void; // Adjust as per your setFavorites structure
    // Add any other shared/contextual props needed by components
}

// Define CmsRendererWrapperProps
export interface CmsRendererWrapperProps {
    message: string | { vendorName: string; cmsData: PageData }; // Can be JSON string or parsed object
    sectionCmsData?: SectionData;
    sectionCmsKey?: string;
    userInfo?: any;
    favorites?: any[];
    setFavorites?: (favorites: any[]) => void;
}


const CMS_HOST = process.env.CMS_HOST;
let CMS_ID_COUNTER = 0;

export const renderText = (text: string | string[], className: string,
    uiCompType: any, props: ComponentRenderProps, variant?: string, extractedStyles?: React.CSSProperties) => {
    if (!text) return null;
    const CustTextComponent = renderFunctions.CustText;
    const sectionData = {
        text,
        uiCompType: {
            className,
            ...uiCompType,
            options: {
                variant,
                ...uiCompType?.options,
            },
            styles: {
                ...uiCompType?.styles,
                ...extractedStyles,
            }
        }
    };
    return <CustTextComponent sectionData={sectionData} props={props} />;
};

export type RenderFunctionType = {
    [key: string]: React.ComponentType<any>;
};

import { useDeviceType } from "@/hooks/useDeviceType";

export const isIosDevice = (): boolean => {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
};


export const renderFunctions: RenderFunctionType = {
    Accordion,
    CategoriesCarousel,
    CirclerImageButton,
    ContentOnImage,
    CustButton,
    CustCarousel,
    CustImage,
    CustText,
    CustVideo,
    ImageButton,
    ItemsGrid,
    MarkdownTextPanel,
    OnPageLoadAction,
    OpenPopup,
    Panel,
    ProductsCarousel,
    Slider
};

export const renderSection = (sectionKey: string, sectionData: SectionData, componentRenderProps: ComponentRenderProps, isSection?: boolean) => {
    //console.log("renderSection...sectionKey: ", sectionKey);
    // sectionData is now directly passed, no need to fetch from componentRenderProps.cmsData.sections
    // sectionData = sectionData || componentRenderProps.cmsData?.sections[sectionKey]; 
    if (!sectionData) {
        console.warn(`No section data found for key: ${sectionKey}. Skipping render.`); // Changed to warn
        return null;
    }
    // Handle cases where uiCompType might be missing after include or by mistake
    const uiCompTypeMethod = sectionData.uiCompType?.method;
    let renderFunction: string = uiCompTypeMethod?.replace(/^render/, '') || "Panel";

    // If method is OpenPopup, ensure it's handled directly by its component, not as a generic panel content.
    // The OpenPopup component itself will decide how to render its internal content.
    if (uiCompTypeMethod === 'renderOpenPopup') {
        renderFunction = 'OpenPopup';
    } else if (uiCompTypeMethod === 'renderOnPageLoadAction') {
        renderFunction = 'OnPageLoadAction';
    }

    const ComponentToRender = renderFunctions[renderFunction] || Panel;


    return (
        isSection ? (
            <section key={sectionKey} style={sectionData.uiCompType?.sectionStyles} className={cssStyles.section}>
                <ComponentToRender sectionData={sectionData} props={componentRenderProps} />
            </section>
        ) : (
            <>
                <ComponentToRender sectionData={sectionData} props={componentRenderProps} />
            </>
        )
    );
};

/**
 * CmsRenderer component is responsible for rendering CMS sections based on the provided props.
 * 
 * @param {any} props - The properties passed to the component.
 * @param {string} props.message - A JSON string containing vendorName and cmsData.
 * @param {object} props.sectionCmsData - Data for a specific CMS section.
 * @param {string} props.sectionCmsKey - Key for a specific CMS section.
 * 
 * @returns {JSX.Element} The rendered CMS sections.
 * 
 * The component first parses the `props.message` to extract `vendorName` and `cmsData`.
 * It then checks if `sectionCmsData` and `sectionCmsKey` are provided.
 * If they are, it renders the specific section using `renderSection` function.
 * If not, it iterates over the `order` array in `cmsData` to render each section in the specified order.
 * 
 * The `order` array in the `cmsData` is crucial as it determines the sequence in which the sections are rendered.
 * Each key in the `order` array corresponds to a section in the `sections` object of `cmsData`.
 * The `renderSection` function is called for each section key, passing the section data and other props.
 */
const CmsRenderer = (props: CmsRendererWrapperProps) => {
    let vendorName: string;
    let cmsData: PageData; // Use PageData type

    try {
        if (typeof props.message === 'string') {
            const parsedMessage = JSON.parse(props.message);
            vendorName = parsedMessage.vendorName;
            cmsData = parsedMessage.cmsData;
        } else if (typeof props.message === 'object' && props.message !== null) {
            vendorName = props.message.vendorName;
            cmsData = props.message.cmsData;
        } else {
            throw new Error("props.message is undefined or not a valid type");
        }
    } catch (error) {
        console.error("Error parsing CMS data from props.message:", error, "props.message was:", props.message);
        return <div>Error loading CMS data. Please try again later. Error : {String(error)}</div>;
    }

    const { sectionCmsData, sectionCmsKey, userInfo, favorites, setFavorites } = props;

    if (!cmsData || (!cmsData.order && !sectionCmsData)) {
        console.warn("CMS data is missing 'order' array or sectionCmsData is not provided.");
        // return <div>CMS content structure is invalid.</div>; // Or render nothing
    }

    const componentRenderProps: ComponentRenderProps = {
        vendorName,
        cmsData,
        userInfo,
        favorites,
        setFavorites
    };


    return (
        <>
            {(sectionCmsData && sectionCmsKey)
                ? <React.Fragment key={sectionCmsKey}>
                    {renderSection(sectionCmsKey, sectionCmsData, componentRenderProps, true)}
                </React.Fragment>
                : cmsData?.order?.map((secKey: string, index: number) => ( // Added optional chaining for cmsData.order
                    <React.Fragment key={secKey}>
                        {secKey && cmsData.sections && cmsData.sections[secKey] && renderSection(secKey, cmsData.sections[secKey], componentRenderProps, (index == 0 ? false : true))}
                    </React.Fragment>
                ))}
        </>
    )
}

export default CmsRenderer;